import { FC } from 'react';
import { Navigate } from 'react-router';

import { selectUnauthenticatedRedirectionPath } from '../../../accounts/selectors/unauthenticated-redirection-path.selector.ts';
import { selectUserAuthStatus } from '../../../accounts/selectors/user-auth-status.selector.ts';
import { DefaultPathEnum } from '../../../main/constants/default-path.ts';
import { useAppSelector } from '../../../main/hooks/use-app-selector.ts';

export const RootScreenProtector: FC = () => {
  const isUserAuthenticated = useAppSelector(selectUserAuthStatus);
  const pathEnum = useAppSelector(selectUnauthenticatedRedirectionPath);

  if (isUserAuthenticated) {
    return <Navigate to={DefaultPathEnum.LEARN_SCREEN} replace />;
  }

  return <Navigate to={pathEnum} replace />;
};
